import { useState } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { validations } from "../../../constants";
import Input from "../../../common/CustomInputOld/input";
import { apiCallV2 } from "../../../utils/api";
import { Loader } from "../../../utils/Loader";
import "../style.css";

import { connect } from "react-redux";
import { BiLoaderCircle } from "react-icons/bi";

const Reset = (props) => {
   const token = new URLSearchParams(window.location.search).get("code");
   const email = new URLSearchParams(window.location.search).get("email");
   const type = new URLSearchParams(window.location.search).get("type");

   const [emailAddress, setEmailAddress] = useState("");
   const [emailIsValid, setEmailIsValid] = useState(true);
   const error = false;
   const success = false;
   const loading = false;
   const [passwords, setPasswords] = useState({
      new: {
         value: "",
         visible: false,
         valid: true,
      },
      confirm: {
         value: "",
         visible: false,
         valid: true,
      },
   });
   const [isResetSuccess, setIsResetSuccess] = useState(false);
   const [isClickSend, setIsClickSend] = useState(false);
   const [isEmailSent, setIsEmailSent] = useState(false);

   const SendResetLink = async (e) => {
      const res = await apiCallV2("POST", "send-reset-password-link", {
         emailAddress: emailAddress,
         type: "admin"
      });

      if (res.data.status == 200 && res.status == 200) {
         setIsClickSend(false);
         setIsEmailSent(true);
      } else {
         setIsClickSend(false);
         toast.error("Email not found.");
      }
   };

   const ResetPassword = async (e) => {
      e.preventDefault();

      const res = await apiCallV2("POST", "reset-password", {
         password: passwords.new.value,
         token: token,
         email: email,
         type: type,
      });
      if (res.data.status === 200 && res.status === 200) {
         toast.success("Password updated successfully");
         setIsResetSuccess(true);
      } else {
         toast.error("Failed to update password");
      }
   };

   return (
      <div className="auth-box" id="reset-page">
         <div className="container">
            <Link to={"/"}>
               <img src="assets/images/logo.png" alt="Indi" height={"40px"} />
            </Link>
            <div className="auth-form">
               {!isResetSuccess ? (
                  <h1
                     className="title-txt text-md-left ta-c"
                     style={{ fontSize: "28px" }}
                  >
                     Reset Password
                  </h1>
               ) : (
                  <h1
                     className="title-txt text-md-left ta-c"
                     style={{ fontSize: "28px", color: "#9fb095" }}
                  >
                     Success
                  </h1>
               )}
               {email && token ? (
                  !isResetSuccess ? (
                     <form>
                        <div className="form-group">
                           <div className="d-flex align-items-center mb-4">
                              <label
                                 style={{
                                    minWidth: "200px",
                                    textAlign: "left",
                                    marginBottom: "5px",
                                 }}
                              >
                                 New Password
                              </label>
                              <div className="input-with-end-icon-wrapper">
                                 <input
                                    className="form-control"
                                    value={passwords.new.value}
                                    type={passwords.new.visible ? "text" : "password"}
                                    onChange={(e) => {
                                       let value = e.target.value;
                                       setPasswords({
                                          ...passwords,
                                          new: {
                                             ...passwords.new,
                                             value: value,
                                             valid: validations.passwordRegex.test(value),
                                          },
                                       });
                                    }}
                                 />
                                 <img
                                    src={`assets/images/${passwords.new.visible ? "eye-off" : "eye"
                                       }.svg`}
                                    alt="Eye"
                                    onClick={() => {
                                       setPasswords({
                                          ...passwords,
                                          new: {
                                             ...passwords.new,
                                             visible: !passwords.new.visible,
                                          },
                                       });
                                    }}
                                 />
                              </div>
                              {passwords.new.valid ? (
                                 ""
                              ) : (
                                 <span className="input-error-label">
                                    Invalid password format! (atleast 8 characters with
                                    numbers, lowercase alpha, and uppercase alpha)
                                 </span>
                              )}
                           </div>
                           <div className="d-flex align-items-center">
                              <label
                                 style={{
                                    minWidth: "200px",
                                    textAlign: "left",
                                    marginBottom: "5px",
                                 }}
                              >
                                 Confirm Password
                              </label>
                              <div className="input-with-end-icon-wrapper">
                                 <input
                                    className="form-control"
                                    value={passwords.confirm.value}
                                    type={passwords.confirm.visible ? "text" : "password"}
                                    onChange={(e) => {
                                       let value = e.target.value;
                                       setPasswords({
                                          ...passwords,
                                          confirm: {
                                             ...passwords.confirm,
                                             value: value,
                                             valid: value === passwords.new.value,
                                          },
                                       });
                                    }}
                                 />
                                 <img
                                    src={`assets/images/${passwords.confirm.visible ? "eye-off" : "eye"
                                       }.svg`}
                                    alt="Eye"
                                    onClick={() => {
                                       setPasswords({
                                          ...passwords,
                                          confirm: {
                                             ...passwords.confirm,
                                             visible: !passwords.confirm.visible,
                                          },
                                       });
                                    }}
                                 />
                              </div>
                              {passwords.confirm.valid ? (
                                 ""
                              ) : (
                                 <span className="input-error-label">
                                    Password didn't match!
                                 </span>
                              )}
                           </div>
                        </div>
                        <div className="text-center">
                           <button
                              className="btn btn-primary d-inline-block"
                              onClick={ResetPassword}
                              disabled={!(passwords.new.valid && passwords.confirm.valid)}
                           >
                              RESET PASSWORD
                           </button>
                        </div>
                     </form>
                  ) : (
                     <p
                        className="success ta-c"
                        style={{
                           margin: 0,
                           fontSize: "17px",
                        }}
                     >
                        Your password has been reset.
                        <p>
                           <Link
                              to={"/login"}
                              style={{ marginLeft: "5px", color: "#9fb095" }}
                           >
                              Go here to log in.
                           </Link>
                        </p>
                     </p>
                  )
               ) : !isEmailSent ? (
                  <form>
                     <div className="form-group">
                        <div className="d-flex align-items-center">
                           <label
                              style={{
                                 minWidth: "200px",
                                 textAlign: "left",
                                 marginBottom: "5px",
                              }}
                           >
                              Email Address
                           </label>
                           <Input
                              style={{
                                 borderColor: "lightgrey",
                                 width: "100%",
                                 marginBottom: "10px",
                              }}
                              type="text"
                              value={emailAddress}
                              name="emailAddress"
                              onChange={(e) => {
                                 setEmailAddress(e.target.value);
                                 setEmailIsValid(
                                    validations.emailRegex.test(e.target.value)
                                 );
                              }}
                              className="i-box"
                           />
                           {emailIsValid ? (
                              ""
                           ) : (
                              <span className="input-error-label">
                                 Invalid email format!
                              </span>
                           )}
                        </div>
                        {error && (
                           <p
                              className="error ta-c"
                              style={{ margin: 0, fontSize: "15px" }}
                           >
                              Email not found!
                           </p>
                        )}
                        {success && (
                           <p
                              className="success ta-c"
                              style={{
                                 margin: 0,
                                 color: "#669b66",
                                 fontSize: "15px",
                              }}
                           >
                              A link to reset your password has been sent to your email.
                              Please check your spam or promotions folder.
                           </p>
                        )}
                     </div>

                     {/* <p className="e-text reset-link">
          <Link to={"/reset-password"}>Reset Password</Link>.
        </p>

        <p className="e-text">
          Don't have an account? <Link to={"/signup"}>Sign Up</Link>.
        </p> */}

                     <div className="text-center">
                        <button
                           className="btn btn-primary d-inline-block"
                           onClick={(e) => {
                              e.preventDefault();
                              if (!isClickSend && emailAddress !== "" && emailIsValid) {
                                 SendResetLink();
                                 setIsClickSend(true);
                              }
                           }}
                        >
                           {isClickSend ? (
                              <BiLoaderCircle className="btn-loading" />
                           ) : (
                              "SEND VERIFICATION"
                           )}
                        </button>
                     </div>
                  </form>
               ) : (
                  <p>
                     If your email address is on file, a link to reset your password
                     has been sent. Please check your spam or promotions folder.
                  </p>
               )}
            </div>
         </div>
         {loading && <Loader loading={loading} />}
      </div>
   );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(Reset);
